import { Link, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

const Header = () => {
  const location = useLocation();

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    // Check if there's a hash in the URL
    if (location.hash) {
      // Remove the '#' and scroll to that element
      const element = document.getElementById(location.hash.slice(1));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  return (
    <header className="bg-[#2E492A] py-4 relative z-50">
      <nav className="container mx-auto px-4 md:px-16 max-w-7xl">
        <div className="flex items-center justify-between">
          {/* Logo and Brand Name */}
          <div className="flex items-center gap-4">
            <img 
              src="/hoasen.jpeg" 
              alt="Lotus Story Logo" 
              className="w-12 h-12 md:w-16 md:h-16 object-contain rounded-full hover-scale"
            />
            <Link to="/" className="font-['Playfair_Display_SC'] text-white text-2xl md:text-3xl font-extrabold hover-fade">
              LOTUS STORY
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden text-white p-2 relative z-50"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>

          {/* Desktop Navigation */}
          <div className="hidden md:flex gap-8 ml-auto font-['Outfit']">
            <Link to="/" className="text-white hover:text-white/80 hover:text-white/80 hover-lift">
              home
            </Link>
            <Link to="/about" className="text-white hover:text-white/80 hover-lift">
              about
            </Link>
            <Link to="/menu" className="text-white hover:text-white/80 hover-lift">
              menu
            </Link>
            <Link to="/gifts" className="text-white hover:text-white/80 hover-lift">
              gifts
            </Link>
            <Link to="/whatson" className="text-white hover:text-white/80 hover-lift">
              what's on
            </Link>
            {/* <Link to="/group" className="text-white hover:text-white/80 hover-lift">
              group
            </Link>
            <a 
              href="https://www.tripadvisor.com.au/Restaurant_Review-g255093-d1764069-Reviews-Lotus_Chinese_Restaurant-Adelaide_Greater_Adelaide_South_Australia.html"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-white/80 hover-lift"
            >
              online orders
            </a> */}
            <Link to="/reservation" className="text-white hover:text-white/80 hover-lift">
              reservation
            </Link>
            <Link to="/join-team" className="text-white hover:text-white/80 hover-lift">
              join our team
            </Link>
          </div>
        </div>

        {/* Mobile Navigation */}
        <div 
          className={`${
            isMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
          } md:hidden fixed inset-0 bg-[#2E492A] transition-all duration-300 ease-in-out`}
          style={{ top: '0', left: '0', right: '0', bottom: '0' }}
        >
          <div className="flex flex-col gap-4 font-['Outfit'] pt-24 px-4">
            <Link 
              to="/" 
              className="text-white hover:text-white/80 py-2 text-xl"
              onClick={() => setIsMenuOpen(false)}
            >
              home
            </Link>
            <Link 
              to="/about" 
              className="text-white hover:text-white/80 py-2 text-xl"
              onClick={() => setIsMenuOpen(false)}
            >
              about
            </Link>
            <Link 
              to="/menu" 
              className="text-white hover:text-white/80 py-2 text-xl"
              onClick={() => setIsMenuOpen(false)}
            >
              menu
            </Link>
            <Link 
              to="/gifts" 
              className="text-white hover:text-white/80 py-2 text-xl"
              onClick={() => setIsMenuOpen(false)}
            >
              gifts
            </Link>
            <Link 
              to="/whatson" 
              className="text-white hover:text-white/80 py-2 text-xl"
              onClick={() => setIsMenuOpen(false)}
            >
              what's on
            </Link>
  
            {/* <Link 
              to="/group" 
              className="text-white hover:text-white/80 py-2 text-xl"
              onClick={() => setIsMenuOpen(false)}
            >
              group
            </Link>
            <a 
              href="https://www.tripadvisor.com.au/Restaurant_Review-g255093-d1764069-Reviews-Lotus_Chinese_Restaurant-Adelaide_Greater_Adelaide_South_Australia.html"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-white/80 py-2 text-xl"
              onClick={() => setIsMenuOpen(false)}
            >
              online orders
            </a> */}
            <Link
              to="/reservation"
              className="text-white hover:text-white/80 py-2 text-xl"
              onClick={() => setIsMenuOpen(false)}
            >
              reservation
            </Link>
            <Link
              to="/join-team"
              className="text-white hover:text-white/80 py-2 text-xl"
              onClick={() => setIsMenuOpen(false)}
            >
              join our team
            </Link>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header; 